// ศูนย์กลางระบบสมาชิก (ยกโครงมาจาก Starbet999 main.js)
// - โหลด mainsetting / theme / checkpoint แล้วแชร์ผ่าน store
// - เปิดหน้า ฝาก ถอน ชวนเพื่อน กงล้อ เช็คอิน ฯลฯ เป็นหน้าต่าง (panel) ทับหน้าเว็บ
// - เปิดได้จาก openPanel('deposit') หรือเข้า URL ตรง เช่น /deposit /withdraw /refer/overview
import React, { Component } from 'react';
import jwt_decode from 'jwt-decode';
import md5 from 'md5';
import instance from '../axios-instance';
import Systems from '../SystemFunction';
import MainSettingContext from './MainSettingContext';
import { t } from './i18n';
import { getLang, subscribeLang, setSiteName } from '../site/i18n';
import { setStore, getStore, settingOf, openLogin, logout } from './store';
import { toast } from './toast';

import Deposit2 from './deposit2';
import Withdraw from './Withdraw';
import Afficiate from './affiliate';
import Luckyfortune from './luckyfortune';
import Checkindaily from './checkin';
import Cardminigame from './cardminigame';
import Promotion from './promotionx';
import Loss from './loss';
import Rebate from './rebate';
import Toprank from './toprank';
import Redeemreward from './redeemreward';
import Statement from './statement';
import Profile from './profile';
import { PANELS, panelFromPath } from './panels';
import './member-scoped.css';
import './memberhub.css';


// [2026-10-30] SEO จาก BO › ตั้งค่า WEBSITE (mainsetting.tblsetting) → <head>
function setMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector('meta[' + attr + '="' + key + '"]');
  if (!el) { el = document.createElement('meta'); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute('content', content);
}
function setLink(rel, href) {
  if (!href) return;
  document.head.querySelectorAll('link[rel="' + rel + '"]').forEach((l, i) => { if (i) l.remove(); });
  let el = document.head.querySelector('link[rel="' + rel + '"]');
  if (!el) { el = document.createElement('link'); el.rel = rel; document.head.appendChild(el); }
  el.href = href;
}
let gtagLoaded = false;
function loadGoogleTag(id) {
  id = String(id || '').trim();
  if (gtagLoaded || !id) return;
  if (/^G-[A-Z0-9]{4,20}$/i.test(id) || /^AW-[0-9]{4,20}$/i.test(id) || /^UA-\d{4,12}-\d{1,4}$/i.test(id)) {
    gtagLoaded = true;
    const sc = document.createElement('script'); sc.async = true; sc.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(id);
    document.head.appendChild(sc);
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    window.gtag('js', new Date()); window.gtag('config', id);
  } else if (/^GTM-[A-Z0-9]{4,12}$/i.test(id)) {
    gtagLoaded = true;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });
    const sc = document.createElement('script'); sc.async = true; sc.src = 'https://www.googletagmanager.com/gtm.js?id=' + encodeURIComponent(id);
    document.head.appendChild(sc);
  } // รูปแบบอื่น (เช่นวางโค้ด <script> ทั้งก้อน) ไม่โหลด — กันสคริปต์แปลกปลอม
}
function applySeo(s) {
  const title = s.title || document.title;
  setMeta('name', 'description', s.description);
  setMeta('name', 'keywords', s.keywords);
  setMeta('property', 'og:title', title);
  setMeta('property', 'og:description', s.description);
  setMeta('property', 'og:site_name', s.siteName);
  setMeta('property', 'og:image', s.logo);
  setMeta('name', 'twitter:title', title);
  setMeta('name', 'twitter:description', s.description);
  const icon = s.favicon || s.logo;
  setLink('icon', icon);
  setLink('apple-touch-icon', icon);
  setMeta('name', 'msapplication-TileImage', icon);
  loadGoogleTag(s.googletag);
}

export default class MemberHub extends Component {
  state = { panel: null, lang: getLang(), setting: null, theme: null, user: { loginstate: false } };

  componentDidMount() {
    this.unsubLang = subscribeLang((lang) => this.setState({ lang }));
    window.addEventListener('memberhub:open', this.onOpen);
    window.addEventListener('memberhub:refresh', this.loadUser);
    window.addEventListener('popstate', this.onPop);
    window.MemberHub = { open: (n) => this.open(n), close: this.close, refresh: this.loadUser };
    this.loadSetting();
    this.loadTheme();
    this.loadUser().then(() => {
      const p = panelFromPath(window.location.pathname);
      if (p) this.open(p, { fromUrl: true });
    });
  }

  componentWillUnmount() {
    this.unsubLang && this.unsubLang();
    window.removeEventListener('memberhub:open', this.onOpen);
    window.removeEventListener('memberhub:refresh', this.loadUser);
    window.removeEventListener('popstate', this.onPop);
  }

  tr = (k) => t(this.state.lang, k);

  // ---------- data ----------
  playerid() {
    const token = localStorage.getItem('auth_token');
    if (!token) return null;
    try { return jwt_decode(token).message.playerid; } catch { return null; }
  }

  loadSetting = async () => {
    try {
      const res = await instance.post('/api/v1/mainsetting', { System: Systems, Playerid: this.playerid() });
      if (res.data.status !== 200) return;
      const s = settingOf(res.data);
      if (s.siteName) setSiteName(s.siteName);
      if (s.title) document.title = s.title;
      else if (s.siteName) document.title = document.title.replace(/Mta159[a-z]*/gi, s.siteName);
      applySeo(s); // [2026-10-30] description / keywords / favicon / og / Google Tag จาก BO
      this.setState({ setting: res.data });
      setStore({ setting: res.data });
    } catch (e) { /* API ไม่ตอบ ใช้ค่าเดิมของธีม */ }
  };

  loadTheme = async () => {
    try {
      const res = await instance.post('/api/v1/getthemesv', { System: Systems });
      if (res.data.status === 200 && res.data.ThmeseV) {
        this.setState({ theme: res.data.ThmeseV });
        setStore({ theme: res.data.ThmeseV });
      }
    } catch (e) { /* ignore */ }
  };

  loadUser = async () => {
    const token = localStorage.getItem('auth_token');
    const Username = this.playerid();
    if (!token || !Username) {
      const user = { loginstate: false };
      this.setState({ user });
      setStore({ user });
      return;
    }
    try {
      const res = await instance.post('/api/v1/checkpoint',
        { userid: Username, System: Systems, Function: 'checkpoint-MemberHub.js' },
        { headers: { Authorization: `Bearer ${token}` } });
      if (res.data.status === 200) {
        localStorage.setItem('auth_token', res.data.token);
        const m = res.data.message;
        const user = {
          loginstate: true,
          username: m.playerid,
          userid: m.member_id,
          firstname: m.firstname,
          lastname: m.lastname,
          point: m.Point,
          balance: res.data.databalance,
          accnumber: m.accnumber,
          tblprofile: m,
          rankpic: res.data.tblrank?.image,
          rankname: res.data.tblrank?.name,
          rankob: res.data.tblrank,
          rankpoint: res.data.rankpoint,
          afficiatetoday: res.data.userafftoday,
          afficiateall: res.data.useraffall,
          linkaff: 'https://' + window.location.host + '/register?reg=' + md5(m.playerid),
        };
        this.setState({ user });
        setStore({ user });
      } else if (res.data.status === 401) {
        this.expired();
      }
    } catch (err) {
      if (err?.response?.status === 401 || err?.response?.status === 403) this.expired();
    }
  };

  expired() {
    localStorage.removeItem('auth_token');
    const user = { loginstate: false };
    this.setState({ user, panel: null });
    setStore({ user });
    toast.error(this.tr('session_expired'));
  }

  // ---------- panel ----------
  onOpen = (e) => this.open(e.detail);

  onPop = () => {
    const p = panelFromPath(window.location.pathname);
    this.setState({ panel: p });
    // กันบั๊ก: เลื่อนหน้าไม่ได้หลังกดย้อนกลับ (ต้องเอา body lock ออกเมื่อไม่มี panel)
    if (p) { document.body.classList.add('mh-open'); window.scrollTo(0, 0); }
    else { document.body.classList.remove('mh-open'); }
  };

  open = (name, opts = {}) => {
    const cfg = PANELS[name];
    if (!cfg) return;
    if (cfg.auth && !getStore().user.loginstate) {
      toast.warning(this.tr('mh_login_required'));
      openLogin();
      return;
    }
    if (!opts.fromUrl && window.location.pathname !== cfg.path) {
      if (!this.state.panel) this.returnTo = window.location.pathname + window.location.search;
      window.history.pushState({ memberhub: name }, '', cfg.path);
    }
    this.setState({ panel: name });
    document.body.classList.add('mh-open');
    window.scrollTo(0, 0); // เปิด panel/โปรฯ แล้วเลื่อนขึ้นบนสุด
    if (cfg.auth) this.loadUser();
  };

  close = () => {
    const back = this.returnTo || '/';
    this.returnTo = null;
    this.setState({ panel: null });
    document.body.classList.remove('mh-open');
    if (panelFromPath(window.location.pathname)) window.history.pushState(null, '', back);
    this.loadUser();
  };

  navigate = (to, e) => {
    if (e && e.preventDefault) e.preventDefault();
    const p = panelFromPath(to);
    if (p) this.open(p);
    else { this.close(); if (to && to !== '/') window.location.href = to; }
  };

  renderPanel() {
    const { panel, lang, user, setting } = this.state;
    const s = settingOf(setting);
    const cat0 = setting && setting.tblcatagoryx && setting.tblcatagoryx[0];
    const limit = cat0 ? { min: cat0.limitdeposit, max: cat0.maxdeposit } : { min: 0, max: 0 };
    const common = {
      language: lang,
      username: user.username,
      userid: user.userid,
      loginstate: user.loginstate,
      balance: user.balance,
      point: user.point,
      tblprofile: user.tblprofile,
      rankpic: user.rankpic,
      rankname: user.rankname,
      rankob: user.rankob,
      rankpoint: user.rankpoint,
      linkaff: user.linkaff,
      linelink: s.linelink,
      limit,
    };
    const byUser = { userid: user.username, loginstate: user.loginstate, language: lang };
    switch (panel) {
      case 'deposit':
        return <Deposit2 onBack={this.close} accnumber={user.accnumber} firstname={user.firstname}
          lastname={user.lastname} limit={limit} language={lang} />;
      case 'withdraw':
        return <Withdraw balance={user.balance} accnumber={user.accnumber} minwithdraw={s.minwithdraw}
          language={lang} onDone={() => { this.loadUser(); this.open('statement'); }} />;
      case 'affiliate': return <Afficiate {...common} />;
      case 'wheel': return <Luckyfortune {...byUser} point={user.point} remaining_amount={user.tblprofile?.remaining_amount || 0} onNavigate={this.navigate} />;
      case 'checkin': return <Checkindaily {...byUser} onNavigate={this.navigate} />;
      case 'cardgame': return <Cardminigame {...byUser} point={user.point} onNavigate={this.navigate} />;
      case 'promotion': return <Promotion {...common} />;
      case 'cashback':
        return <Loss {...common} maxwithdrawstatus={cat0 ? cat0.withdrawmax : 0}
          webnamex={setting && setting.message && setting.message[7] && setting.message[7].value}
          cashoutSet={setting && setting.tblcashoutsetting && setting.tblcashoutsetting[0]}
          inviteSet={setting && setting.tblinvitedsetting && setting.tblinvitedsetting[0]} />;
      case 'rebate':
        return <Rebate {...common} cashoutSet={setting && setting.tblcashoutsetting && setting.tblcashoutsetting[0]} />;
      case 'toprank': return <Toprank {...common} />;
      case 'redeem': return <Redeemreward {...common} />;
      case 'statement': return <Statement {...byUser} />;
      case 'profile': return <Profile {...byUser} />;
      default: return null;
    }
  }

  render() {
    const { panel, setting, theme, lang } = this.state;
    return (
      <MainSettingContext.Provider value={{ ...(setting || {}), language: lang }}>
        {panel && (
          <div className="mh-overlay" role="dialog" aria-modal="true" aria-label={this.tr(PANELS[panel].label)}
            onMouseDown={(e) => { if (e.target === e.currentTarget) this.close(); }}>
            <div className="mh-dialog">
              <div className="mh-dialog-head">
                <span className="mh-dialog-title">{this.tr(PANELS[panel].label)}</span>
                <button type="button" className="mh-close" aria-label={this.tr('close')} onClick={this.close}>×</button>
              </div>
              <div className="mh-scope" data-theme={theme || undefined} key={panel}>
                {this.renderPanel()}
              </div>
            </div>
          </div>
        )}
      </MainSettingContext.Provider>
    );
  }
}

export { logout, PANELS, panelFromPath };
